import React from 'react';
import Header from './Header';
import TestimonialCard from './TestimonialCard';
import LoginForm from './LoginForm';
import { Container } from '@/Components/ui/container';
import { Stack, Inline } from '@/Components/ui/layout';

const testimonials = [
  {
    id: 1,
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/902ea8595168f3b0ea80e450eaeeaed64de78a89e879e3e7bc1b1adf1e4a804b?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f",
    quote: "The user-friendly interface and targeted job alerts helped me secure a fantastic role in a competitive industry.",
    author: "Nina Verma",
    role: "Content Strategist"
  },
  {
    id: 2,
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/2c3bd3b5eb2afba3430bb144ffde997b9a25e5b615d82a94b7877e233ec365d4?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f",
    quote: "The user-friendly interface and targeted job alerts helped me secure a fantastic role in a competitive industry.",
    author: "Nina Verma",
    role: "Content Strategist"
  },
  {
    id: 3,
    image: "https://cdn.builder.io/api/v1/image/assets/TEMP/a6af0ae2ab9cf5a19e7dba986972778140edce3ea63402ddc0ff106ad32ea7da?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f",
    quote: "The user-friendly interface and targeted job alerts helped me secure a fantastic role in a competitive industry.",
    author: "Nina Verma",
    role: "Content Strategist"
  }
];

function SignUpPage() {
  return (
    <main className="bg-slate-950 min-h-screen flex justify-center">
      <div className="w-full mr-12 ml-12">
        <Header />
        <Container>
          <Inline spacing="lg" className="gap-5 mt-14 w-full flex-col md:flex-row">
            <div className="mt-16 md:mt-5 min-w-0">
              <Stack spacing="md">
                {testimonials.map(testimonial => (
                  <TestimonialCard key={testimonial.id} {...testimonial} />
                ))}
              </Stack>
            </div>
            <div className="mt-5 min-w-0">
              <LoginForm />
            </div>
          </Inline>
        </Container>
      </div>
    </main>
  );
}

export default SignUpPage;